export default __webpack_public_path__ + "static/media/miquela.88808542.png";